import { PlusOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";

import { PendoProps } from "../../utils/pendo";
import { Button } from "../Button";

import * as theme from "./AddFilterButton.css";

export interface AddFilterButtonProps extends PendoProps {
    addLabel?: string;
    items: MenuProps["items"];
}
export function AddFilterButton({
    addLabel,
    items,
    "data-pendo": dataPendo,
}: AddFilterButtonProps) {
    return (
        <Dropdown
            menu={{ items }}
            trigger={["click"]}
            overlayClassName={theme.overlay}
        >
            <div className={theme.trigger}>
                <Button variant="primary" data-pendo={dataPendo}>
                    <PlusOutlined />
                    {addLabel}
                </Button>
            </div>
        </Dropdown>
    );
}
